module.exports = __webpack_public_path__ + "static/partnerstvo-20a3e8f1b29e59ddb45844e0044cd63c.jpg";